import { useQuery } from 'react-query';
import { EmailTemplateService } from '../services/EmailTemplateService';

export const useEmailTemplate = (id: number, expand?: string[]) => {
  return useQuery({
    queryKey: ['email_template', id],
    queryFn: async () => await EmailTemplateService.get(id, expand),
    enabled: !!id,
  });
};
